import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  // Bulk Disbursement List
  BULK_DISBURSEMENT_LIST: null,
  BULK_DISBURSEMENT_LIST_SUCCESS: null,
  BULK_DISBURSEMENT_LIST_FAILED: null,
  BULK_DISBURSEMENT_LIST_SHOW_MODAL: null,
  BULK_DISBURSEMENT_LIST_COLUMN: null,
  BULK_DISBURSEMENT_LIST_CREATE: null,

  // Bulk Disbursement Detail
  BULK_DISBURSEMENT_DETAIL: null,
  BULK_DISBURSEMENT_DETAIL_SUCCESS: null,
  BULK_DISBURSEMENT_DETAIL_FAILED: null,
  BULK_DISBURSEMENT_DETAIL_SHOW_MODAL: null,
  BULK_DISBURSEMENT_DETAIL_COLUMN: null,

  // Bulk Disbursement Detail Transaction
  BULK_DISBURSEMENT_DETAIL_TRANSACTION: null,
  BULK_DISBURSEMENT_DETAIL_TRANSACTION_SUCCESS: null,
  BULK_DISBURSEMENT_DETAIL_TRANSACTION_FAILED: null,

  // Admin fee
  ADMIN_FEE_PRECREATION: null,
  ADMIN_FEE_PRECREATION_SUCCESS: null,
  ADMIN_FEE_PRECREATION_FAILED: null,
});
